import { render, staticRenderFns } from "./CompanyId.vue?vue&type=template&id=0bbc956d&"
import script from "./CompanyId.vue?vue&type=script&lang=js&"
export * from "./CompanyId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports